import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router'
import Home from '../views/Home.vue'
import store from '../store/index';
const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/attacks',
    name: 'Attacks',
    component: () => import(/* webpackChunkName: "attacking" */ '../views/Attacking.vue')
  },
  {
    path: '/crimes',
    name: 'Crimes',
    component: () => import(/* webpackChunkName: "crimes" */ '../views/Crimes.vue')
  },
  {
    path: '/gym',
    name: 'Gym',
    component: () => import(/* webpackChunkName: "gym" */ '../views/Gym.vue')
  },
  {
    path: '/players/:player_id',
    name: 'Player Info',  
    component: () => import(/* webpackChunkName: "players" */ '../views/PlayerInfo.vue')
  },
  {
    path: '/players',
    name: 'Players',  
    component: () => import(/* webpackChunkName: "players" */ '../views/Players.vue')
  },
  {
    path: '/items',
    name: 'Items',  
    component: () => import(/* webpackChunkName: "items" */ '../views/Items.vue')
  },
 
  {
    path: '/test',
    name: 'Test',  
    component: () => import(/* webpackChunkName: "test" */ '../views/Test.vue')
  },
]

const router = createRouter({
  history: createWebHashHistory(),// createWebHistory(process.env.BASE_URL),
  routes
});

router.beforeEach((to, from, next) => {
    store.commit('setCurrentScreen', to.name);
    // console.log("CURRENT SCREEN", store.state.navigation);
    // store.dispatch('getLogs');
    next();
});

export default router
